import { generateTestId } from "@client-shared";

const COMPONENT = "AdminCrossBorderView";

export const setAdminCrossBorderViewTestId = (identifier: string): string => generateTestId(COMPONENT, identifier);
